"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  days: ["Неделя", "Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота"],
  daysShort: ["Нед", "Пон", "Вто", "Сря", "Чет", "Пет", "Съб"],
  daysMin: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
  months: ["Януари", "Февруари", "Март", "Април", "Май", "Юни", "Юли", "Август", "Септември", "Октомври", "Ноември", "Декември"],
  monthsShort: ["Яну", "Фев", "Мар", "Апр", "Май", "Юни", "Юли", "Авг", "Сеп", "Окт", "Ное", "Дек"],
  today: "Днес",
  clear: "Изчисти",
  dateFormat: "dd.MM.yyyy",
  timeFormat: 'HH:mm',
  firstDay: 1
};
exports.default = _default;